module.exports = __webpack_public_path__ + "static/media/brex-banner.dfc95d05.png";